import React from 'react';
import ReactDOM from 'react-dom/client';
import './static/scss/index.scss';
import App from './App';
import {ConfigProvider} from 'antd';
import reportWebVitals from './reportWebVitals';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ConfigProvider locale={zhCN} autoInsertSpaceInButton={false}>
            <App/>
        </ConfigProvider>
    </React.StrictMode>
);
reportWebVitals();
